import { AGREEMENT_STATUSES } from '../types/agreements.types';
import type { AgreementStatus } from '../types/agreements.types';

const STATUS_LABEL: Record<AgreementStatus, string> = {
    draft: 'Draft',
    active: 'Active',
    on_hold: 'On Hold',
    suspended: 'Suspended',
    pending_cancellation: 'Pending Cancellation',
    cancelled: 'Cancelled',
    cancellation_reversed: 'Cancellation Reversed',
    pending_transfer: 'Pending Transfer',
    transferred: 'Transferred',
    transfer_reversed: 'Transfer Reversed',
    pending_claim: 'Pending Claim',
    expired: 'Expired',
    completed: 'Completed',
    renewed: 'Renewed',
    dead: 'Dead',
};

export const isKnownAgreementStatus = (status: string): status is AgreementStatus =>
    (AGREEMENT_STATUSES as string[]).includes(status);

/** An unrecognised status renders verbatim — shared by the badge and the
 *  invoicing warning so there is exactly one status-to-label map (F9). */
export function statusLabel(status: AgreementStatus | string): string {
    return isKnownAgreementStatus(status) ? STATUS_LABEL[status] : status;
}

const SERVICEABLE_STATUSES: readonly string[] = [
    'active',
    'on_hold',
    'suspended',
    'pending_cancellation',
    'cancellation_reversed',
    'pending_transfer',
    'transfer_reversed',
];

/** Mirrors AgreementState::acceptsAuthorisedContactChanges(). An allow-list, so an
 *  unrecognised status fails closed; the server is the boundary either way. */
export const isServiceableStatus = (status: string): boolean => SERVICEABLE_STATUSES.includes(status);
